import { resource, RequestConfig } from '../helper/resource';

/**
 * [No Auth]基金概况
 */
export function queryFundProfileUsingPOST_1(
  req: InfoCodeDto | void,
  config?: RequestConfig
): Promise<ApiResultFundInfoDto> {
  return resource.postNoAuth('/fundProfile/queryFundProfile', req, config);
}
